import React from 'react';
import './PlatformSettings.css';

const PlatformSettings = () => {
  return (
    <div className="platform-settings">
      <div className="page-header">
        <h1>Platform Settings</h1>
        <p>Configure platform-wide settings</p>
      </div>

      <div className="settings-placeholder">
        <p>Platform settings coming soon...</p>
      </div>
    </div>
  );
};

export default PlatformSettings;

